var _path, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeichen1PxPfeilExtern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.762 23.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-black",
    stroke: "none",
    d: "m11.881,23.762c6.562,0,11.881-5.319,11.881-11.881S18.443,0,11.881,0,0,5.319,0,11.881s5.319,11.881,11.881,11.881"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "text-white",
    fill: "none",
    stroke: "currentColor",
    points: "7.567 8.1341 15.346 8.1341 15.346 15.9131"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "text-white",
    fill: "none",
    stroke: "currentColor",
    x1: 7.9822,
    y1: 15.4984,
    x2: 15.3702,
    y2: 8.1104
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeichen1PxPfeilExtern);
export default __webpack_public_path__ + "static/media/Zeichen-1px_pfeil-extern.c95adcfe19fead8b2c0f30be6b1f2b81.svg";
export { ForwardRef as ReactComponent };